import { NextPage } from 'next'
import { staticProps } from '../../utils/createApolloClient'
import PlaylistsLayout from './components/PlaylistsLayout'
import styles from './_playlistsPage.module.scss'

const PlaylistsPage: NextPage = () => {
  return (
    <PlaylistsLayout>
      <div className={styles.playlistsAbout}>
        <p>
          Looking for a convenient and organized way to discover and enjoy your
          favorite songs? Our playlist pages offer a comprehensive collection of
          categories, making it easy to find the music you love!
        </p>
        <p>
          Our categories are carefully curated to provide a diverse and engaging
          selection of songs for every mood, occasion, and taste. From upbeat
          and energetic to mellow and reflective, our playlist pages have it
          all.
        </p>

        <p>
          Whether you&apos;re in the mood for classic hits, modern pop songs, or
          inspiring worship music, our categories make it easy to find exactly
          what you&apos;re looking for. And with new songs and categories added
          regularly, you&apos;ll always have fresh and exciting music to enjoy.
        </p>

        <p>
          Plus, our playlist pages are incredibly user-friendly, making it easy
          to navigate and explore the vast selection of songs. Simply click on
          the category that interests you, and you&apos;ll be directed to a page
          full of songs that perfectly match your preferences.
        </p>

        <p>
          So why wait? Start exploring our playlist pages today and discover
          your new favorite songs! Whether you&apos;re looking to dance, relax,
          or worship, our categories have everything you need to create the
          perfect playlist for any occasion.
        </p>
      </div>
    </PlaylistsLayout>
  )
}

export const getStaticProps = staticProps({})

export default PlaylistsPage
